import Flickity from "flickity";

class TestimonialSlider {
  constructor(block) {
    this.block = block;
    this.slides = block.querySelector(".testimonial-slider__slides");

    if (!this.slides) {
      return;
    }

    this.flickityInit();
  }

  flickityInit() {
    this.flkty = new Flickity(this.slides, {
      pageDots: false,
      autoPlay: 6500,
      wrapAround: true,
      prevNextButtons: false,
      adaptiveHeight: true,
      resize: true,
      contain: true,
      imagesLoaded: true,
      cellAlign: "left",
      pauseAutoPlayOnHover: true,
    });
  }
}

export default TestimonialSlider;
